import { isDevopsFeatureDisabledInFedRamp } from '@jira/software__devops-fedramp-utils/src/isDevopsFeatureDisabledInFedRamp.tsx';
import { fg } from '@atlassian/jira-feature-gating';

export const isSecurityPageEnabled = (): boolean =>
	!isDevopsFeatureDisabledInFedRamp() && fg('isotopes-security-page-in-jira-enabled-v2');
